module.exports = __webpack_public_path__ + "static/img/subscriptionExpired.07e363e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/inventory/subscriptionExpired.png
// module id = u+us
// module chunks = 134